import { ChannelRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class ChannelService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ChannelRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	authorizeAmazon(oAuthDate) {
		var url = this.routeService.authorizeAmazon(oAuthDate);
		return this.apiClient.post(url);
	}

	authorizationResultAmazon(state) {
		var url = this.routeService.authorizationResultAmazon(state);
		return this.apiClient.get(url);
	}

	updateChannelWarehouseCodes(updateChannelWarehouseCodesParams, sourceOfChange) {
		var url = this.routeService.updateChannelWarehouseCodes(updateChannelWarehouseCodesParams, sourceOfChange);
		return this.apiClient.post(url, updateChannelWarehouseCodesParams);
	}

	updateChannelAmazonTemplates(updateChannelAmazonTemplatesParams, sourceOfChange) {
		var url = this.routeService.updateChannelAmazonTemplates(updateChannelAmazonTemplatesParams, sourceOfChange);
		return this.apiClient.post(url, updateChannelAmazonTemplatesParams);
	}

	updateChannelCustomLabel(updateChannelCustomLabelParams, sourceOfChange) {
		var url = this.routeService.updateChannelCustomLabel(updateChannelCustomLabelParams, sourceOfChange);
		return this.apiClient.put(url, updateChannelCustomLabelParams);
	}

	getGoFlowStores = async resource => {
		var url = this.routeService.getGoFlowStores(resource);
		return this.apiClient.post(url, resource);
	};

	getSellerCloudCompanies = async resource => {
		var url = this.routeService.getSellerCloudCompanies(resource);
		return this.apiClient.post(url, resource);
	};

	getSellerCloudUrl = teamName => {
		const url = this.routeService.getSellerCloudUrl(teamName);
		return this.apiClient.get(url);
	}
}

export default ChannelService;



// WEBPACK FOOTER //
// ./src/common/data/services/ChannelService.js